export const OraMuiAutocomplete = {
  styleOverrides: {
    root: {
      '& .MuiFormControl-root label': {
        display: 'none',
      },
      '& .MuiAutocomplete-popupIndicator': {
        color: 'var(--type-heading)',
      },
      '& .MuiInputBase-root.Mui-disabled': {
        color: 'var(--type-heading)',
        opacity: 0.75,
        '&:hover': {
          borderColor: 'transparent',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
          },
        },
      },
    },
  },
};
